
import { mapState } from 'vuex'
import ReviewStars from '@/components/ReviewStars'
import ProductImage from '@/components/ProductImage'

export default {
  components: {
    ReviewStars,
    ProductImage,
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    spaceBeneath: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(['cdn']),
  },
  methods: {
    goToProduct() {
      this.$router.push(this.$getLink(this.product.link))
    },
  },
}
